<template>
    <div class="pa-2">
        <!-- delete dialog -->
        <v-delete-dialog
			v-model="deleteDialog"
			:module="'detailsTypes/delete'"
			:parameters="{ id: itemId ? itemId : null }"
			@on-delete="getAll">
			<!-- {{ $T('.delete-message') }} -->
              هل أنت متأكد أنك تريد الحذف ؟
		</v-delete-dialog>

        <!-- dialog -->
        <v-dialog
			v-model="dialog"
			max-width="400px"
			transition="dialog-transition"
        >
			<v-card>
				<v-card-title primary-title>
					إضافة نوع تفصيل جديد
					<v-spacer></v-spacer>
					<v-btn
						@click="dialog = false"
						icon>
						<v-icon color="alert-color">mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-1">
					<v-row dense>
						<v-col cols="6">
							<v-text-field
								v-model="name"
								outlined
								dense
								label="الاسم"
								hide-details
                                :disabled="submitLoading"
                                ></v-text-field>
						</v-col>

                        <v-col cols="6">
							<v-autocomplete
								v-model="type"
                                :items="detailTypes"
                                item-text="name"
                                item-value="id"
								outlined
								dense
								label="النوع"
								hide-details
                                :disabled="submitLoading"
                            />
						</v-col>

                        <v-col cols="12">
                            <h5>
                                أنواع الخيارات:
                            </h5>
                            <bee-handy-smart-table
                                refs="table"
                                v-model="tableInputs"
                                :items="selectTypes"
                                :headers="headersType"
                                :items-per-page="-1"
                                :show-add-row="!submitLoading && type === 2"
                                hide-default-footer
                                dense
                                zebra
                                @keypress.enter="addTypeOption()"
                            >
                                <template v-slot:item.actions="{ index }">
                                    <tooltip :text="$T('tooltips.delete')">
                                        <v-btn
                                            depressed
                                            rounded
                                            icon
                                            small
                                            @click="deleteItem({ index })"
                                            :disabled="submitLoading"
                                        >
                                            <v-icon
                                                size="20"
                                                color="alert-color">
                                                $delete
                                            </v-icon>
                                        </v-btn>
					                </tooltip>
                                </template>
                            </bee-handy-smart-table>
                        </v-col>

                        <v-col>
                            <v-checkbox
                                v-model="withNotes"
                                label="مع ملاحظات"
                                class="mt-0 pt-0"
                                :disabled="submitLoading"
                                hide-details
                            />
                        </v-col>

                        <v-col>
                            <v-checkbox
                                v-model="xprotected"
                                label="محمي "
                                class="mt-0 pt-0"
                                :disabled="submitLoading"
                                hide-details
                            />
                        </v-col>
					</v-row>
				</v-card-text>
				<v-card-actions class="align-center pt-0">
					<v-spacer></v-spacer>
					<v-btn
						color="secondary"
						:disabled="submitLoading || !name "
						:loading="submitLoading"
                        @click="submit()"
                        >
						{{ $T('default-buttons.save') }}
                        
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
        <v-row>
            <v-spacer />
            <v-col cols="auto">
				<v-btn
					@click="dialog = true"
					small
					color="primary">
					<v-icon left> $add </v-icon>
					{{ $T('add') }}
				</v-btn>
			</v-col>
        </v-row>
        <bee-handy-table 
            :headers="headers"
            :items="detailsTypes"
            dense
            zebra
            :items-per-page="-1"
            hide-default-footer
            class="mt-2"
        >
            <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-end">
                    <tooltip :text="$T('tooltips.edit')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; dialog = true"
                            >
                            <v-icon
                                size="20"
                                color="edit-color">
                                $edit
                            </v-icon>
                        </v-btn>
                    </tooltip>

                    <tooltip :text="$T('tooltips.delete')">
                        <v-btn
                            depressed
                            rounded
                            icon
                            small
                            @click="itemId = item.id; deleteDialog = true"
                            >
                            <v-icon
                                size="20"
                                color="alert-color  ">
                                $delete
                            </v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { detailTypes } from '@/utils/enum'

export default {
    watch: {
        dialog(val) {
            if(val && this.itemId !== null) {
                const item = this.getById(this.itemId)
                console.log(item.detailTypeOptions)
                this.name = item?.name
                this.type = item.types
                this.selectTypes = item.detailTypeOptions.map(c =>( { name: c.name, id: c.detailTypeId }))
                this.withNotes = item.withNotes
                this.xprotected = item.protected
            } else {
                this.name = null 
                this.type = null
                this.itemId = null
                this.selectTypes  = []
                this.withNotes = false
                this.xprotected = false
                this.$refs.table.refs.resetInputs()
            }
        }
    },
    data () {
        return {
            detailTypes,
            loading: false,
            itemId: null,
            deleteDialog: false,

            headersType: [
                {
                    text: 'الاسم',
                    name: 'name',
                    value: 'name'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions',
                    noInput: true
                }
            ],
            dialog: false,
            name: null,
            type: null,
            selectTypes: [],
            tableInputs: {},
            xprotected: false,
            withNotes: false,
            submitLoading: false
        }
    },

    computed: {
        ...mapState({
            detailsTypes: state => state.detailsTypes.detailsTypes
        }),

        ...mapGetters({
            getById: 'detailsTypes/getById'
        }),

        headers() {
            return [
                {
                    text: 'الاسم',
                    name: 'name',
                    value: 'name'
                },
                {
                    text: 'النوع',
                    name: 'types',
                    value: 'types',
                    setValueExpr: val => this.detailTypes.find(c => c.id === val)?.name
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        addTypeOption() {
            this.selectTypes.push({
                ...this.tableInputs
            })
        },

        deleteItem(index) {
            this.selectTypes.splice(index, 1)
        },

        submit() {
            this.submitLoading = true
            const actionName = this.itemId ? 'update' : 'create'
            this.$store.dispatch(`detailsTypes/${actionName}`, {
                name: this.name,
                detailTypesOptions: this.selectTypes,
                detailTypes: this.type,
                Xprotected: this.xprotected, 
                withNotes: this.withNotes,
                id: this.itemId ? this.itemId : null
            }).then(() => {
                this.getAll()
            }).finally(() => {
                this.submitLoading = false
                this.dialog = false
            })
        },

        getAll() {
            this.loading = true
            this.$store.dispatch('detailsTypes/fetchAll').then((data) => {
                console.log(data)
            }).finally(() => {
                this.loading = false
            })
        }
    },

    created() {
        this.getAll()
    }
}
</script>
